import TrashIcon from "../images/trash.svg?react";

/**Default: 20px by 20px */
export default function CoreDeleteIcon({
	height = 20,
	width = 20,
	color = "#B40030",
}: {
	width?: string | number;
	height?: string | number;
	/**@default "#B40030" */
	color?: string;
}) {
	return <TrashIcon width={width} height={height} color={color} />;
}
